export default "__VITE_ASSET__B6Igsq$g__"